import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useScrollArrows } from 'site-modules/shared/hooks/use-scroll-arrows';
import { SpeculationRule } from 'site-modules/shared/components/speculation-rule/speculation-rule';
import { YearLinkItem } from './year-link-item';

import './year-links-carousel.scss';

const ARROW_CLASS_NAME = 'arrow pos-a d-flex align-items-center justify-content-center bg-white border-0 text-blue-40';

// TODO: Probably move to other-review-years after core-7872
export function YearLinksCarousel({
  years = [],
  currentYear = null,
  className = null,
  heading = null,
  headingClassName = 'heading-5 mb-0_75',
  hasSpeculationRule = false,
  linkTrackingId = 'see_other_years_core',
  creativeId = 'years-module',
}) {
  const containerRef = useRef();
  const [arrows, scrollLeft, scrollRight] = useScrollArrows(containerRef);

  return (
    <div className={classnames('year-links-carousel', className)} data-tracking-parent={creativeId}>
      {!!heading && <div className={headingClassName}>{heading}</div>}
      <div className="pos-r">
        <button
          className={classnames(ARROW_CLASS_NAME, 'left left-0', {
            invisible: !arrows.left,
          })}
          onClick={scrollLeft}
          aria-label="Scroll model years left"
        >
          <i className="icon-arrow-left3" aria-hidden />
        </button>

        <ul
          ref={containerRef}
          className={classnames('years-list list-unstyled d-flex gap-1 overflow-x-auto p-0_25', {
            'fade-left': arrows.left,
            'fade-right': arrows.right,
          })}
        >
          {years.map(({ core7872: { imageUrl, name, year, url, noFollow } }) => (
            <YearLinkItem
              key={`year-${name}`}
              name={name}
              year={year}
              url={url}
              imageUrl={imageUrl}
              noFollow={noFollow}
              currentYear={currentYear}
              trackingId={linkTrackingId}
            />
          ))}
        </ul>

        <button
          className={classnames(ARROW_CLASS_NAME, 'right right-0', {
            invisible: !arrows.right,
          })}
          onClick={scrollRight}
          aria-label="Scroll model years right"
        >
          <i className="icon-arrow-right3" aria-hidden />
        </button>
      </div>

      {hasSpeculationRule && (
        <SpeculationRule observeRef={containerRef} selector=".year-links-carousel a" notSelector="[rel~=nofollow]" />
      )}
    </div>
  );
}

YearLinksCarousel.propTypes = {
  years: PropTypes.arrayOf(
    PropTypes.shape({
      core7872: PropTypes.shape({
        name: PropTypes.string,
        year: PropTypes.string,
        imageUrl: PropTypes.string,
        url: PropTypes.string,
        noFollow: PropTypes.bool,
      }),
    })
  ),
  currentYear: PropTypes.string,
  className: PropTypes.string,
  heading: PropTypes.string,
  headingClassName: PropTypes.string,
  hasSpeculationRule: PropTypes.bool,
  linkTrackingId: PropTypes.string,
  creativeId: PropTypes.string,
};
